import { render, staticRenderFns } from "./RealNameHome.vue?vue&type=template&id=1aca1cc7&"
import script from "./RealNameHome.vue?vue&type=script&lang=js&"
export * from "./RealNameHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports